var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls062(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 75,
    viewBox: "0 0 93 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3647 39.7525C61.5646 39.6529 69.7486 40.4996 77.7543 42.2758C89.6224 45.2018 91.4214 49.6399 91.4214 52.029C91.4214 54.4181 89.6313 58.8562 77.7543 61.7822C61.6718 65.1472 45.0666 65.1472 28.9841 61.7822C17.116 58.8562 15.3259 54.4181 15.3259 52.029C15.3259 49.6399 17.116 45.2018 28.9841 42.2758C36.987 40.501 45.1679 39.6543 53.3647 39.7525Z",
    fill: "#FDFDFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.06
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8189 40.4861C60.7871 40.39 68.7397 41.2126 76.5193 42.9378C88.0384 45.7654 89.8105 50.0962 89.8105 52.3958C89.8105 54.6954 88.0205 59.0261 76.5193 61.8537C60.8767 65.1277 44.7253 65.1277 29.0827 61.8537C17.5547 59.0261 15.7915 54.6954 15.7915 52.3958C15.7915 50.0962 17.5815 45.7654 29.0827 42.9378C36.8738 41.2089 44.8388 40.3862 52.8189 40.4861Z",
    fill: "#FAFBFE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2729 41.2197C60.0118 41.1269 67.7357 41.9225 75.2931 43.5908C86.472 46.3378 88.2084 50.4986 88.2084 52.7624C88.2084 55.0262 86.472 59.187 75.2931 61.934C60.1092 65.0955 44.4365 65.0955 29.2526 61.934C18.0737 59.187 16.3284 55.0173 16.3284 52.7624C16.3284 50.5075 18.1184 46.3378 29.2526 43.5908C36.81 41.9225 44.534 41.1269 52.2729 41.2197Z",
    fill: "#F8F9FD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7267 41.9891C59.2492 41.8981 66.7572 42.6727 74.1025 44.2977C84.9324 46.982 86.633 50.9817 86.633 53.174C86.633 55.3662 84.9145 59.4374 74.1025 62.0502C59.3671 65.1164 44.158 65.1164 29.4225 62.0502C18.5927 59.3659 16.8921 55.3662 16.8921 53.174C16.8921 50.9817 18.6106 46.9105 29.4225 44.2977C36.7445 42.6782 44.2282 41.9036 51.7267 41.9891Z",
    fill: "#F6F7FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1809 42.6783C58.4621 42.5941 65.7292 43.3416 72.8406 44.9063C83.3304 47.4654 85.013 51.3666 85.013 53.4962C85.013 55.6258 83.3304 59.5181 72.8406 62.0772C58.5568 65.048 43.8141 65.048 29.5302 62.0772C19.0405 59.5181 17.3489 55.6258 17.3489 53.4962C17.3489 51.3666 19.0405 47.4654 29.5302 44.9063C36.6387 43.3416 43.9027 42.594 51.1809 42.6783Z",
    fill: "#F3F5FC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.635 43.4118C57.6869 43.3317 64.7251 44.0521 71.6145 45.5593C81.7552 48.0378 83.42 51.8228 83.42 53.8629C83.42 55.9031 81.7552 59.679 71.6145 62.1576C57.7778 65.0208 43.5011 65.0208 29.6644 62.1576C19.5236 59.679 17.8589 55.8941 17.8589 53.8629C17.8589 51.8318 19.5236 48.0378 29.6644 45.5593C36.5507 44.0519 43.586 43.3315 50.635 43.4118Z",
    fill: "#F1F3FB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0891 44.1458C56.9125 44.0629 63.723 44.7594 70.3884 46.2217C80.2337 48.6018 81.8179 52.2257 81.8179 54.2211C81.8179 56.2165 80.1889 59.8493 70.3884 62.2742C57 65.0413 43.187 65.0413 29.7987 62.2742C19.9981 59.8941 18.3691 56.2702 18.3691 54.2211C18.3691 52.172 19.9981 48.6018 29.7987 46.2217C36.461 44.7598 43.2686 44.0633 50.0891 44.1458Z",
    fill: "#EFF1FA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5519 44.8793C56.143 44.8009 62.7218 45.4704 69.162 46.8747C78.6135 49.1743 80.2156 52.6639 80.2156 54.5877C80.2156 56.5115 78.6135 60.0101 69.162 62.3097C56.221 64.9702 42.8738 64.9702 29.9328 62.3097C20.4813 60.0101 18.8792 56.5205 18.8792 54.5877C18.8792 52.655 20.4813 49.1743 29.9328 46.8747C36.376 45.4699 42.9577 44.8005 49.5519 44.8793Z",
    fill: "#ECEFFA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.006 45.6133C55.3595 45.5389 61.7009 46.1843 67.9091 47.5371C77.0115 49.7383 78.5957 53.0938 78.5957 54.9549C78.5957 56.8161 77.0115 60.1805 67.9091 62.3817C55.4195 64.9468 42.5388 64.9468 30.0492 62.3817C20.9378 60.1805 19.3625 56.825 19.3625 54.9549C19.3625 53.0848 20.9378 49.7383 30.0492 47.5371C36.2749 46.1803 42.6346 45.5349 49.006 45.6133Z",
    fill: "#EAEDF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4601 46.3379C54.5935 46.2684 60.7153 46.8898 66.7097 48.1901C75.472 50.3107 77.0204 53.5588 77.0204 55.3484C77.0204 57.138 75.472 60.3681 66.7097 62.5067C54.6686 64.9762 42.2514 64.9762 30.2104 62.5067C21.4481 60.395 19.8997 57.138 19.8997 55.3484C19.8997 53.5588 21.4481 50.3376 30.2104 48.1901C36.2046 46.8888 42.3265 46.2675 48.4601 46.3379Z",
    fill: "#E8EBF9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9139 47.0716C53.819 47.0068 59.7126 47.6071 65.4833 48.8612C73.8966 50.8834 75.4182 53.9615 75.4182 55.6974C75.4182 57.4333 73.8966 60.5114 65.4833 62.5425C53.8827 64.9172 41.9219 64.9264 30.3176 62.5694C21.9043 60.5382 20.3828 57.4601 20.3828 55.7242C20.3828 53.9884 21.9043 50.9103 30.3176 48.8881C36.0961 47.623 41.9988 47.0136 47.9139 47.0716Z",
    fill: "#E5E9F8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.39
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3683 47.8057C53.0438 47.7415 58.7087 48.3117 64.2575 49.5058C72.3128 51.4385 73.8254 54.3913 73.8254 56.0556C73.8254 57.7199 72.3307 60.6727 64.2575 62.6054C53.1152 64.8723 41.6303 64.8723 30.488 62.6054C22.4328 60.6727 20.9202 57.7199 20.9202 56.0556C20.9202 54.3913 22.4149 51.4385 30.488 49.5058C36.0338 48.3117 41.6957 47.7414 47.3683 47.8057Z",
    fill: "#E3E7F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8218 48.5393C52.2682 48.4748 57.7049 49.018 63.0308 50.1589C70.755 52.0111 72.2228 54.8208 72.2228 56.4224C72.2228 58.0241 70.755 60.8338 63.0308 62.686C52.3357 64.8453 41.3168 64.8453 30.6217 62.686C22.8976 60.8338 21.4297 58.0241 21.4297 56.4224C21.4297 54.8208 22.8976 52.0111 30.6217 50.1589C35.9446 49.0179 41.3783 48.4747 46.8218 48.5393Z",
    fill: "#E1E5F7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2761 49.2727C51.4938 49.2098 56.7023 49.729 61.8048 50.8206C69.1888 52.6102 70.6298 55.2946 70.6298 56.7889C70.6298 58.2832 69.1888 61.0034 61.8048 62.7571C51.5583 64.821 41.0029 64.821 30.7563 62.7571C23.3724 60.9676 21.9314 58.2832 21.9314 56.7889C21.9314 55.2946 23.3724 52.5744 30.7563 50.8206C35.856 49.7295 41.0614 49.2103 46.2761 49.2727Z",
    fill: "#DEE3F6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.739 50.0424C50.7248 49.9871 55.7015 50.4823 60.5786 51.5188C67.6136 53.1921 69.0277 55.7243 69.0277 57.2007C69.0277 58.6771 67.6136 61.2094 60.5786 62.8737C50.7835 64.8422 40.6946 64.8422 30.8995 62.8737C23.8556 61.2094 22.4414 58.6682 22.4414 57.2007C22.4414 55.7332 23.8556 53.1921 30.8995 51.5188C35.7764 50.4813 40.7532 49.9862 45.739 50.0424Z",
    fill: "#DCE1F5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1932 50.7316C49.9503 50.6781 54.6988 51.1492 59.3525 52.1365C66.0473 53.7113 67.4078 56.1183 67.4078 57.5052C67.4078 58.8922 66.0294 61.3081 59.3525 62.874C50.0047 64.735 40.3816 64.735 31.0338 62.874C24.339 61.2902 22.9785 58.8922 22.9785 57.5052C22.9785 56.1183 24.3658 53.6934 31.0338 52.1365C35.6876 51.1492 40.4361 50.6781 45.1932 50.7316Z",
    fill: "#DADEF5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.638 51.4652C49.1659 51.4153 53.6857 51.8593 58.1172 52.7895C64.463 54.2748 65.8234 56.5476 65.8234 57.8897C65.8234 59.2319 64.463 61.4689 58.1172 62.9811C49.2179 64.7468 40.0582 64.7468 31.1589 62.9811C24.8131 61.4957 23.4526 59.223 23.4526 57.8897C23.4526 56.5565 24.8131 54.3106 31.1589 52.7895C35.5904 51.8593 40.1102 51.4153 44.638 51.4652Z",
    fill: "#D8DCF4"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1012 52.1987C48.3998 52.1529 52.6908 52.5699 56.9001 53.4425C62.8968 54.8473 64.2304 57.0216 64.2304 58.2475C64.2304 59.4734 62.8968 61.6566 56.9001 63.0615C48.4481 64.7199 39.7542 64.7199 31.3022 63.0615C25.3055 61.6566 23.9719 59.527 23.9719 58.2475C23.9719 56.968 25.3055 54.8473 31.3022 53.4425C35.5116 52.5705 39.8026 52.1535 44.1012 52.1987Z",
    fill: "#D5DAF3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.61
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5552 52.9325C47.6251 52.8888 51.688 53.2818 55.674 54.1046C61.3305 55.411 62.6283 57.4154 62.6283 58.5786C62.6283 59.7418 61.3305 61.7909 55.674 63.0525C47.6735 64.6153 39.446 64.6153 31.4455 63.0525C25.7889 61.7461 24.4822 59.7418 24.4822 58.5786C24.4822 57.4154 25.7889 55.3752 31.4455 54.1046C35.4285 53.2818 39.4883 52.8888 43.5552 52.9325Z",
    fill: "#D3D8F3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0092 53.6661C46.8621 53.6191 50.7088 53.9851 54.4836 54.7578C59.7911 55.9836 61.071 57.8448 61.071 58.9811C61.071 60.1175 59.7911 61.9876 54.4836 63.2046C46.9314 64.671 39.1676 64.671 31.6155 63.2046C26.308 61.9876 25.0281 60.1265 25.0281 58.9811C25.0281 57.8358 26.308 55.9836 31.6155 54.7578C35.3639 53.9906 39.1833 53.6246 43.0092 53.6661Z",
    fill: "#D1D6F2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.68
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4721 54.3911C46.0786 54.3525 49.679 54.6974 53.2125 55.4201C58.1799 56.5476 59.424 58.2745 59.424 59.3482C59.424 60.422 58.1799 62.1489 53.2125 63.2853C46.1165 64.6418 38.8277 64.6418 31.7318 63.2853C26.7644 62.1489 25.5203 60.422 25.5203 59.3482C25.5203 58.2745 26.7644 56.5476 31.7318 55.4201C35.2653 54.6976 38.8657 54.3527 42.4721 54.3911Z",
    fill: "#CED4F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.71
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.953 55.1248C45.3333 55.0892 48.708 55.4071 52.0221 56.0733C56.6404 57.1113 57.8667 58.704 57.8667 59.7151C57.8667 60.7262 56.6404 62.3279 52.0221 63.3569C45.3689 64.6215 38.537 64.6215 31.8839 63.3569C27.2566 62.3279 26.0393 60.7262 26.0393 59.7151C26.0393 58.704 27.2566 57.1113 31.8839 56.0733C35.1979 55.4066 38.5727 55.0887 41.953 55.1248Z",
    fill: "#CCD2F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.74
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3803 55.8584C44.5324 55.8311 47.6789 56.131 50.7691 56.7531C55.0474 57.7016 56.2378 59.169 56.2378 60.1086C56.2378 61.0481 55.0474 62.5155 50.7691 63.464C44.5576 64.6234 38.1851 64.6234 31.9735 63.464C27.6953 62.5155 26.5049 61.0481 26.5049 60.1086C26.5049 59.169 27.6953 57.7016 31.9735 56.7531C35.0695 56.1293 38.2221 55.8294 41.3803 55.8584Z",
    fill: "#CAD0F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.77
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8344 56.5922C43.7569 56.5584 46.6751 56.8253 49.543 57.3886C53.4722 58.2386 54.6358 59.5718 54.6358 60.4487C54.6358 61.3256 53.4722 62.6588 49.543 63.5089C43.7858 64.5707 37.8829 64.5707 32.1257 63.5089C28.1965 62.6588 27.033 61.3256 27.033 60.4487C27.033 59.5718 28.1965 58.2386 32.1257 57.3886C34.9936 56.8253 37.9118 56.5584 40.8344 56.5922Z",
    fill: "#C7CEF0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.81
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2884 57.3261C42.9907 57.2939 45.6894 57.5337 48.3436 58.0419C51.9238 58.8114 53.0694 60.0015 53.0694 60.8157C53.0694 61.63 51.9327 62.8201 48.3436 63.5806C43.035 64.5471 37.5954 64.5471 32.2868 63.5806C28.7067 62.8201 27.561 61.63 27.561 60.8157C27.561 60.0015 28.7067 58.8114 32.2868 58.0419C34.9235 57.5373 37.604 57.2975 40.2884 57.3261Z",
    fill: "#C5CCEF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.84
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7425 58.0957C42.2075 58.0703 44.6689 58.2891 47.0907 58.7489C50.3307 59.42 51.4405 60.4759 51.4405 61.2275C51.4405 61.9791 50.3307 63.0171 47.0907 63.7061C42.2325 64.5651 37.2613 64.5651 32.4032 63.7061C29.1543 63.0261 28.0444 61.9702 28.0444 61.2275C28.0444 60.4848 29.1543 59.4379 32.4032 58.7489C34.822 58.2891 37.2805 58.0703 39.7425 58.0957Z",
    fill: "#C3CAEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.87
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1964 58.7844C41.4322 58.7626 43.665 58.9543 45.8644 59.357C48.7643 59.9476 49.8473 60.8692 49.8473 61.5492C49.8473 62.2293 48.7643 63.1509 45.8644 63.7325C41.4548 64.4961 36.9468 64.4961 32.5373 63.7325C29.6374 63.1509 28.5544 62.2293 28.5544 61.5492C28.5544 60.8692 29.6374 59.9476 32.5373 59.357C34.7337 58.9548 36.9635 58.763 39.1964 58.7844Z",
    fill: "#C0C8EE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6594 59.5181C40.6636 59.4988 42.6652 59.6666 44.6382 60.0192C47.189 60.5113 48.2183 61.2987 48.2183 61.9161C48.2183 62.5335 47.1622 63.312 44.6382 63.8131C40.6764 64.4693 36.6335 64.4693 32.6717 63.8131C30.1208 63.312 29.0916 62.5246 29.0916 61.9161C29.0916 61.3077 30.1477 60.5113 32.6717 60.0192C34.6477 59.6667 36.6523 59.499 38.6594 59.5181Z",
    fill: "#BEC6ED"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.94
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1133 60.2517C39.8884 60.2366 41.6614 60.3774 43.4119 60.6723C45.6136 61.0839 46.6429 61.7281 46.6429 62.2739C46.6429 62.8198 45.6136 63.473 43.4119 63.8846C39.9018 64.4453 36.3248 64.4453 32.8147 63.8846C30.604 63.473 29.5747 62.8287 29.5747 62.2739C29.5747 61.7192 30.604 61.0839 32.8147 60.6723C34.5651 60.3766 36.3382 60.2359 38.1133 60.2517Z",
    fill: "#BCC4EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.97
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5674 60.9857C39.1135 60.9742 40.6581 61.0879 42.1858 61.3257C44.0475 61.6568 45.0499 62.1579 45.0499 62.6411C45.0499 63.1243 44.0475 63.6343 42.1858 63.9564C39.1245 64.4217 36.0104 64.4217 32.9491 63.9564C31.0874 63.6343 30.085 63.1243 30.085 62.6411C30.085 62.1579 31.0874 61.6568 32.9491 61.3257C34.4768 61.0879 36.0213 60.9742 37.5674 60.9857Z",
    fill: "#B9C2EC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4479 63.0077C43.4479 63.7235 40.5748 64.3051 37.0215 64.3051C33.4683 64.3051 30.5952 63.7235 30.5952 63.0077C30.5952 62.2919 33.4683 61.7192 37.0215 61.7192C40.5748 61.7192 43.4479 62.2919 43.4479 63.0077Z",
    fill: "#B7C0EB"
  })))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9417 61.1414C63.2654 54.0142 68.2871 37.4384 61.1579 24.1183C54.0288 10.7982 37.4484 5.77789 24.1247 12.9051C10.801 20.0323 5.77932 36.6081 12.9085 49.9282C20.0376 63.2483 36.618 68.2686 49.9417 61.1414Z",
    fill: "url(#paint0_linear_230_1787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_1787",
    x1: 24.1247,
    y1: 12.9051,
    x2: 49.9308,
    y2: 61.1473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE4FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls062);
export default __webpack_public_path__ + "static/media/ils_06_2.bb72f41420e4dd1524cfca0d12b72cc1.svg";
export { ForwardRef as ReactComponent };